import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { changelogEntity } from './changelog.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as ChangelogActions from './changelog.actions';

export const CHANGELOG_FEATURE_KEY = 'changelog';

export interface ChangelogState extends EntityState<changelogEntity> {
  changelog: changelogEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const changelogAdapter: EntityAdapter<changelogEntity> = createEntityAdapter<changelogEntity>();

export const initialChangelogState: ChangelogState = changelogAdapter.getInitialState({
  changelog: null,
  loaded: true,
  error: null,
});

const reducer = createReducer(
  initialChangelogState,
  on(ChangelogActions.loadChangelog, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(ChangelogActions.loadChangelogSuccess, (state, { changelog }) => ({
    ...state,
    changelog: changelog,
    loaded: true,
    error: null,
  })),
  on(ChangelogActions.loadChangelogFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  }))
);

export function changelogReducer(state: ChangelogState | undefined, action: Action) {
  return reducer(state, action);
}
